import gql from "graphql-tag";

export const GET_IMAGE_EVENT = gql`
  query business_council_image_gallery_view($limit: Int, $offset: Int) {
    business_council_image_gallery_view(limit: $limit, offset: $offset) {
      id
      image_url
    }
    business_council_image_gallery_view_aggregate {
      aggregate {
        count
      }
    }
  }
`;
